import { useState } from 'react'
import { Button, Checkbox, TableCell, TableRow, useTheme } from '@mui/material'

import { UpdateQuantityType } from '../update-quantity-type'
import { useMe, useTableItemsCheck } from 'src/hooks'

import { IQuantityTypeBaseWithId } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IQuantityTypesRowProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IQuantityTypeBaseWithId
}

const QuantityTypesRow = ({ row, isItemSelected, handleItemCheck }: IQuantityTypesRowProps) => {
  const [open, setOpen] = useState(false)

  const { data: user } = useMe()
  const theme = useTheme()

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  return (
    <>
      <TableRow
        key={row.id}
        style={{
          borderTop: `1px solid ${theme.palette.custom.grey}`,
          borderBottom: `1px solid ${theme.palette.custom.grey}`,
        }}
        sx={{ 'td, th': { border: 0 } }}
      >
        <TableCell>
          <Checkbox
            checked={isItemSelected(row.id)}
            onChange={handleItemCheck(row.id)}
            sx={{ color: theme.palette.custom.grey2 }}
          />
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.category?.name || '-'}</TableCell>
        <TableCell align="center">
          {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell align="center">
          {getTableTimestamp({ date: row.updated_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell>
          <Button onClick={handleOpen}>
            <HelperWrapper t="update-button-text" />
          </Button>
        </TableCell>
      </TableRow>
      <UpdateQuantityType handleClose={handleClose} open={open} initialValues={row} />
    </>
  )
}

export { QuantityTypesRow }
